import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatExpansionModule} from '@angular/material/expansion';
import { AssessmentRoutingModule } from './assessment-routing.module';
import { GtapMaterialsModule } from '../gtap-materials/gtap-materials.module';
import { AssessmentsComponent } from './components/assessments/assessments.component';
import { InstructionComponent } from './components/instruction/instruction.component';
import { QuestionairesComponent } from './components/questionaires/questionaires.component';
import { CategoriesComponent } from './components/categories/categories.component';
import * as fromAssessment from '../store/assessment/assessment.reducer';
import { AssessmentEffects } from '../store/assessment/assessment.effects';
import { MatRadioModule } from '@angular/material/radio';
import { AssessmentReviewComponent } from './components/assessment-review/assessment-review.component';
import { AssesmentListComponent } from './components/assesment-list/assesment-list.component';

@NgModule({
  declarations: [
    AssessmentsComponent,
    InstructionComponent,
    QuestionairesComponent,
    CategoriesComponent,
    AssessmentReviewComponent,
    AssesmentListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    GtapMaterialsModule,
    MatExpansionModule,
    AssessmentRoutingModule,
    StoreModule.forFeature(
      fromAssessment.assessmentFeatureKey,
      fromAssessment.reducer
    ),
    EffectsModule.forFeature([AssessmentEffects]),
  ]
})
export class AssessmentModule {}
